module.exports = __webpack_public_path__ + "img/recepient-content.094f64c0.svg";